import { FunctionComponent } from 'react';

import Icon from '../Icon';
import { IconPropsInterface } from '../Icon.types';

const KeyboardSpaceIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => (
  <Icon size={size} color={color} {...rest}>
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path d="M18 9v4H6V9H4v6h16V9z" fill="currentColor" />
  </Icon>
);

KeyboardSpaceIcon.displayName = 'KeyboardSpaceIcon';

export default KeyboardSpaceIcon;
